import React from 'react';
import { useCartContext } from '../customHooks/useCart';
import { groupProductBlocksByRiskGroup } from '../utils/groupProductsByRiskGroup';
import CartViewProductRow from './CartViewProductRow';
import RiskGroupProductWarning from './RiskGroupProductWarning';

type Props = {
  products: CartProductView[];
  showQuantityControl?: (product: CartProductView) => boolean;
  rowClassName?: string;
  wasUpgradedToPremium?: boolean;
  isCannabisCatalog?: boolean;
};

const RiskGroupedProductList: React.FC<Props> = ({ products, showQuantityControl, rowClassName = 'py-3', wasUpgradedToPremium, isCannabisCatalog }) => {
  const { getCart } = useCartContext();
  const cart = getCart();
  const blocks = groupProductBlocksByRiskGroup(products);

  return <>
    {blocks.map((block, blockIndex) => {
      const riskGroup = block.riskGroupID ? cart.risk_groups?.find((group) => group.id === block.riskGroupID) : undefined;
      const blocked = Boolean(riskGroup && riskGroup.status !== 'clear');
      return (
        <div key={`${block.riskGroupID || 'product'}-${blockIndex}`}>
          <div className={blocked ? 'flex flex-col rounded-[10px] p-[16px]' : ''} style={blocked ? { border: '1px solid #df5555' } : undefined}>
            {block.products.map((product, productIndex) => (
              <div key={product.product_item_id} className={blocked ? `${productIndex > 0 ? 'pt-[8px]' : ''} ${productIndex < block.products.length - 1 ? 'pb-[8px] border-b border-[#e5e7eb]' : ''}` : ''}>
                <CartViewProductRow
                  cartViewProduct={product}
                  showQuantityControl={showQuantityControl?.(product)}
                  className={rowClassName}
                  wasUpgradedToPremium={wasUpgradedToPremium}
                  isCannabisCatalog={isCannabisCatalog}
                />
              </div>
            ))}
            {blocked && riskGroup && <RiskGroupProductWarning riskGroup={riskGroup} />}
          </div>
          {blocked && <div className="mt-[8px] h-px w-full shrink-0 bg-[#e5e7eb]" />}
        </div>
      );
    })}
  </>;
};

export default RiskGroupedProductList;
